import React from 'react';
import { useLocation } from 'react-router-dom';
import cn from 'classnames';

import { CONFIG } from 'constants/index';
import { useAnalytics, useTranslation, useAppDispatch } from 'client/hooks';
import { useAppSelector } from 'client/hooks/redux';
import { setPopup } from 'client/redux/ui';
import { selectUserGAStatus } from 'client/redux/user/selectors';
import { State as AuthState } from 'client/components/common/Login/state';
import Button from 'client/components/common/Button';

import icon from 'client/assets/403/error-page-icon.svg';
import bg from 'client/assets/403/403-bg.jpeg';

import css from './PageError.module.scss';

type Props = {
  className?: string;
  message?: string;
};

export function PageError(props: Props) {
  const { className = '' } = props;
  const t = useTranslation().createPrefixedTranslationFunc('mandate.pageError');
  const location = useLocation();
  const dispatch = useAppDispatch();
  const analytics = useAnalytics();
  const userGAStatus = useAppSelector(selectUserGAStatus);

  React.useEffect(() => {
    if (userGAStatus) {
      analytics.gtag.event('page_view', {
        page_title: `403`,
        page_location: `${CONFIG.domainUrl}${location.pathname}`,
      });
    }
  }, [userGAStatus]);

  const onLoginClick = (type: AuthState['authType']) => {
    dispatch(setPopup({ type: 'auth', data: { initialAuthType: type } }));
  };

  return (
    <div className={cn(css.pageError, className)} style={{ backgroundImage: `url(${bg})` }}>
      <img src={icon} alt="icon no access" className={css.icon} />
      <h6 className={css.title}>{t('title')}</h6>
      <p className={css.message}>{t('message')}</p>
      <div className={css.buttons}>
        <Button className={css.signInBtn} size="medium" onClick={() => onLoginClick('sign-in')}>
          {t('btnLoginLabel')}
        </Button>
        <Button className={css.signUpBtn} size="medium" onClick={() => onLoginClick('sign-up')}>
          {t('btnSignUpLabel')}
        </Button>
      </div>
    </div>
  );
}

export default PageError;
